import { AccordionView } from "../../common/accordion/accordion.view"
import { IAccordionData } from "../../common/interfaces/accordionData"
import { IWaterMeterPoint } from "../../Types/WaterMeterTypes"
import { parseDateToString } from "../../common/utilities/parser"
import { Table } from "react-bootstrap"

type WaterMeterPointProps = {
    point: IWaterMeterPoint,
}

const WaterMeterPoint = (props: WaterMeterPointProps) => {


    function createAccordionData(point: IWaterMeterPoint): IAccordionData[] {
        let accordionData: { title: string; content: JSX.Element }[] = [];

        if (!point.waterMeters || point.waterMeters.length === 0) {
            return accordionData;
        }

        point.waterMeters.map( (waterMeter, index) => {
            const hasReadings = waterMeter.waterMeterReadings && 
                                Array.isArray(waterMeter.waterMeterReadings) && 
                                waterMeter.waterMeterReadings.length > 0;

            let orderedReadings: any[] = [];
            if (hasReadings) {
                orderedReadings = [...waterMeter.waterMeterReadings].sort(
                    (a,b) => new Date(b.readingDate).getTime() - new Date(a.readingDate).getTime()
                );
            }

            accordionData.push({
                title: "Vannmåler " + waterMeter.serialNo,
                content: (<>
                <Table key={index} striped hover size="sm" responsive borderless>
                    <tbody>
                    <tr>
                        <td>Serienummer</td>
                        <td>{waterMeter.serialNo ?? "Ukjent"}</td>
                    </tr>
                    <tr>
                        <td>Montert</td>
                        <td>{waterMeter.attachmentDate ? parseDateToString(waterMeter.attachmentDate) : "Ukjent"}</td>
                    </tr>
                    <tr>
                        <td>Kalkulert årlig forbruk</td>
                        <td>{waterMeter.calculatedYearlyConsumption ?? "Ukjent"} m<sup>3</sup></td>
                    </tr>
                    {hasReadings && orderedReadings.length > 0 && (
                        <tr>
                            <td>Siste avlesning ({orderedReadings[0]?.readingDate ? parseDateToString(orderedReadings[0].readingDate) : "Ukjent dato"})</td>
                            <td>{orderedReadings[0]?.reading ?? "Ukjent"} m<sup>3</sup></td>
                        </tr>
                    )}
                    <tr>
                        <td>Automatisk avlesning</td>
                        <td>{waterMeter.automaticMeter !== null && waterMeter.automaticMeter !== undefined ? (waterMeter.automaticMeter ? "Ja" : "Nei") : "Ukjent"}</td>
                    </tr>
                    <tr>
                        <td>Plassering</td>
                        <td>{point.placement ?? "Ukjent"}</td>
                    </tr>
                    </tbody>
                </Table>
                {hasReadings ? (
                    <>
                        <h2>Avlesninger</h2>
                        <Table striped hover size="sm" responsive borderless>
                            <thead className="tableHeader">
                                <tr>
                                    <th>Dato</th>
                                    <th className="text-end pe-5">Avlest målerstand</th>
                                    <th className="text-end pe-5">Forbruk siden forrige avlesning</th>
                                    <th>Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderedReadings.map( (reading, index) => {
                                    return (
                                    <tr key={index} className="">
                                        <td>{reading?.readingDate ? parseDateToString(reading.readingDate) : "Ukjent dato"}</td>
                                        <td className="text-end pe-5">{reading?.reading ?? "Ukjent"} m<sup>3</sup></td>
                                        <td className="text-end pe-5">{reading?.consumptionCalculated ?? "Ukjent"} m<sup>3</sup></td>
                                        <td>{reading?.readingFormDescription ?? "Ukjent"}</td>
                                    </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </>
                ) : (
                    <p><em>Ingen avlesninger tilgjengelig for denne vannmåleren.</em></p>
                )}
                </>)
            })
        })
        return accordionData;
    }
    

    return <AccordionView showNarrow={true} content={createAccordionData(props.point)} />
}

export default WaterMeterPoint